import { pickFromListSeeded } from '@SonarCX/utilities'

export const getTypeName = (types: TaskType[], id: string) => {
  if (!id) {
    return 'No type'
  }

  const type = types.find(type => type.id === id)
  return type?.name ?? 'Unknown type'
}

export const getTypeColor = (id: string) => {
  const colors = [
    '#ff6961',
    '#f49ac2',
    '#ff964f',
    '#77dd77',
    '#befd73',
    '#89cff0',
    '#c1c6fc',
    '#bdb0d0',
    '#cb99c9',
    '#ca9bf7'
  ]

  return pickFromListSeeded(colors, id)
}
